import { render, staticRenderFns } from "./PeopleIcon.vue?vue&type=template&id=031b161a&scoped=true&"
import script from "./PeopleIcon.vue?vue&type=script&lang=js&"
export * from "./PeopleIcon.vue?vue&type=script&lang=js&"
import style0 from "./PeopleIcon.vue?vue&type=style&index=0&id=031b161a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b161a",
  null
  
)

export default component.exports